.section {
  padding: 7.5rem 0;
  background: var(--color-background);
}

.container {
  max-width: 74rem;
  margin: 0 auto;
  padding: 0 2rem;
  box-sizing: content-box;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.title {
  margin: 0;
}

.controls {
  display: flex;
  gap: 0.5rem;
}

// The row runs edge to edge, with its first card aligned to the heading.
// Native scrolling stays free: toggling mandatory snapping can jump during page scrolling.
.track {
  --inset: max(2rem, calc((100% - 74rem) / 2));

  display: flex;
  gap: 1rem;
  margin: 0;
  padding: 0.25rem var(--inset) 0.75rem;
  overflow-x: auto;
  list-style: none;
  scroll-padding-inline: var(--inset);
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.card {
  display: flex;
  flex: 0 0 min(18rem, 80vw);
  flex-direction: column;
  gap: 0.5rem;

  h3 {
    margin-top: 0.25rem;
  }
}

.coverLink {
  display: block;
  width: 100%;
  border-radius: var(--radius-lg);
}

.cover {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  transition:
    border-color 150ms ease,
    transform 150ms ease;

  .coverLink:hover & {
    border-color: var(--color-primary-border);
    transform: translateY(-2px);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    .coverLink:hover & {
      transform: none;
    }
  }
}

@media (max-width: 640px) {
  .section {
    padding: 3rem 0;
  }

  .container {
    padding: 0 1rem;
  }

  .track {
    --inset: 1rem;

    gap: 1rem;
  }
}

.cardTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

// In a docs article the page supplies the heading. The row runs to the page's edges (past the
// article column and the page padding), with its first card still aligned to the text.
.docs {
  margin: 1.5rem 0 0;

  .container {
    max-width: none;
    padding: 0;
  }

  .header {
    justify-content: flex-end;
    margin-bottom: 1rem;
  }

  .track {
    --inset: var(--docs-page-bleed, 0px);

    margin-inline: calc(-1 * var(--inset));
  }
}
